<template>
  <header id="hd">
    <!-- head -->
    <div id="head">
      <h1 style="font-size:20px;line-height: 13.5px;">
        <router-link :to="{name: 'home'}">
          <img :src="`${publicPath}img/common/main_logo.png`" alt="">
        </router-link>
      </h1>
      <div id="nav">
        <one-day-header-nav />
      </div>
      <div class="btn_menu open" @click="menu">
        <div class="nav-icon">
          <div></div>
        </div>
      </div>
    </div>
    <!-- e : head -->

    <!-- head_mobile -->
    <div id="head_mobile" :class="{'open': open}">
      <div class="top">
        <h1 style="font-size:20px;line-height: 13.5px;">
          <router-link :to="{name: 'home'}"><img :src="`${publicPath}img/common/main_logo.png`" alt=""></router-link>
        </h1>
        <div class="btn_menu close" @click="menu">
          <div class="nav-icon">
            <div></div>
          </div>
        </div>
      </div>
      <div id="nav_m">
        <one-day-header-nav :mobile="true" :open="open" @close="close" />
      </div>
    </div>
    <!-- e : head_mobile -->
  </header>
  <!-- e : header -->
</template>

<script>
import OneDayHeaderNav from './OneDayHeaderNav.vue';

export default {
  name: 'OneDayHeader',
  components: { OneDayHeaderNav },
  data() {
    return {
      open: false,
    };
  },
  mounted() {
    console.log(this.publicPath);
  },
  methods: {
    menu() {
      this.open = !this.open;
    },
    close() {
      this.open = false;
    },

  },
};
</script>

<style scoped>

</style>
